import React, {useState, useEffect} from 'react';
import { API_ROOT } from '../../../../baseUrls';
import {connect} from 'react-redux';
import {
  Typography,
  Box,
  Container,
  Button,
  TextField,
  LinearProgress,
  Grid,
} from '@material-ui/core';
import MindfilesTable from './MindfilesTable';

function ManageMindfiles({mid}) {
  const [mindfileName, setMindfileName] = useState('');
  const [username, setUsername] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [mindfiles, setMindfiles] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [orderBy, setOrderBy] = useState('created_at');
  const [reverseOrder, setReverseOrder] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const searchMindfiles = () => {
    setIsLoading(true);
    fetch(`${API_ROOT}/mindfiles/${mid}/admin/manage?page=${pageNumber}&mindfile_name=${mindfileName}&username=${username}&user_email=${userEmail}&order=${orderBy}&reverse=${reverseOrder}`, {
      method: 'GET',
      credentials: 'include',
    })
    .then(resp => resp.json())
    .then(data => setMindfiles(data))
    .catch(error => console.error(error))
    .finally(() => setIsLoading(false))
  }

  useEffect(searchMindfiles, [pageNumber, orderBy, reverseOrder]);

  return (
    <Container>
      <Box mt={3}>
        <Typography variant='h4'>
          Manage Mindfiles
        </Typography>
        <Box mt={5}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                variant="outlined"
                size="small"
                type="text"
                placeholder="Mindfile"
                value={mindfileName}
                onChange={e => setMindfileName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                variant="outlined"
                size="small"
                type="text"
                placeholder="Owner"
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                variant="outlined"
                size="small"
                type="text"
                placeholder="Email"
                value={userEmail}
                onChange={e => setUserEmail(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Button
                variant="contained"
                onClick={searchMindfiles}>
                Find
              </Button>
            </Grid>
          </Grid>
        </Box>  
      </Box>
      <Box mt={5}>
        { isLoading ?
        <Box>
          <h3>Loading</h3>
          <LinearProgress />
        </Box>
        : <MindfilesTable
            mindfiles={mindfiles}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            reverseOrder={reverseOrder}
            setReverseOrder={setReverseOrder}
          /> }
      </Box>
    </Container>
  );
}

const mapStateToProps = state => ({
  mid: state.auth.mid
})

export default connect(mapStateToProps)(ManageMindfiles);